import ActivateGenericModal from '../../components/sections/modals/activateGenericModal';
import ActivateZapperModal from '../../components/sections/modals/activateZapperModal';
import AnonymousGenericModal from '../../components/sections/modals/anonymousGenericModal';
import AnonymousZapperModal from '../../components/sections/modals/anonymousZapperModal';
import ChannelNotAllowedModal from '../../components/sections/modals/channelNotAllowedModal';
import ClosePlayerModal from '../../components/sections/modals/closePlayerModal';
import DeadmanZapperModal from '../../components/sections/modals/deadmanZapperModal';
import ExitAppModal from '../../components/sections/modals/exitAppModal';
import GenericErrorModal from '../../components/sections/modals/genericErrorModal';
import LogoutModal from '@components/sections/modals/logoutModal';
import Modals from '../../../shared/types/enums/modals';
import ParentalPinGenericModal from '../../components/sections/modals/parentalPinGenericModal';
import ParentalPinZapperModal from '../../components/sections/modals/parentalPinZapperModal';
import PlayerErrorModal from '../../components/sections/modals/playerErrorModal';
import PlayerLanguageModal from '../../components/sections/modals/playerLanguageModal';
import RecordingDeleteModal from '../../components/sections/modals/recordingDeleteModal';
import RecordingRequestModal from '../../components/sections/modals/recordingRequestModal';
import SubscribeAddonModal from '../../components/sections/modals/subscribeAddonModal';
import UpgradeAddonModal from '../../components/sections/modals/upgradeAddonModal';
import UpgradePlanModal from '../../components/sections/modals/upgradePlansModal';
import UpgradeRecordPlanModal from '../../components/sections/modals/upgradeRecordPlanModal';
import ZoomModal from '../../components/elements/modal/zoomModal';
import { modalSelector } from '../../../shared/store/slices/modal.slice';
import { useAppSelector } from '../../../shared/store/hooks';

/**
 * Modal manager component that renders the appropriate modal based on current modal state.
 * Acts as a router for all modal types in the application.
 *
 * @returns {JSX.Element | null} The active modal component or null if no modal is active
 */
export default function ModalManager() {
  const modal = useAppSelector(modalSelector);
  switch (modal.current) {
    case Modals.ANONYMOUS_GENERIC:
      return <AnonymousGenericModal />;
    case Modals.ANONYMOUS_ZAPPER:
      return <AnonymousZapperModal />;
    case Modals.ACTIVATE_GENERIC:
      return <ActivateGenericModal />;
    case Modals.ACTIVATE_ZAPPER:
      return <ActivateZapperModal />;
    case Modals.CHANNEL_NOT_ALLOWED:
      return <ChannelNotAllowedModal />;
    case Modals.CLOSE_PLAYER:
      return <ClosePlayerModal />;
    case Modals.DEADMAN_ZAPPER:
      return <DeadmanZapperModal />;
    case Modals.EXIT_APP:
      return <ExitAppModal />;
    case Modals.GENERIC_ERROR:
      return <GenericErrorModal />;
    case Modals.LOGOUT:
      return <LogoutModal />;
    case Modals.PARENTAL_PIN_GENERIC:
      return <ParentalPinGenericModal />;
    case Modals.PARENTAL_PIN_ZAPPER:
      return <ParentalPinZapperModal />;
    case Modals.PLAYER_ERROR:
      return <PlayerErrorModal />;
    case Modals.PLAYER_LANGUAGE:
      return <PlayerLanguageModal />;
    case Modals.RECORDING_DELETE:
      return <RecordingDeleteModal />;
    case Modals.RECORDING_REQUEST:
      return <RecordingRequestModal />;
    case Modals.SUBSCRIBE_ADDON:
      return <SubscribeAddonModal />;
    case Modals.UPGRADE_ADDON:
      return <UpgradeAddonModal />;
    case Modals.UPGRADE_PLAN:
      return <UpgradePlanModal />;
    case Modals.UPGRADE_RECORD_PLAN:
      return <UpgradeRecordPlanModal />;
    case Modals.ZOOM:
      return <ZoomModal />;
  }
  return null;
}
